import { MenuLayoutMode } from '../types/kundali';

export const MENU_LAYOUT_STORAGE_KEY = 'astro_menu_layout_mode';

/**
 * Returns the user's preferred menu layout mode ('horizontal' | 'vertical').
 * Defaults to 'horizontal' per canonical workstation specification.
 */
export function getMenuLayoutModePref(): MenuLayoutMode {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const saved = window.localStorage.getItem(MENU_LAYOUT_STORAGE_KEY);
      if (saved === 'vertical' || saved === 'horizontal') {
        return saved;
      }
    }
  } catch {}
  return 'horizontal'; // Default to horizontal view
}

/**
 * Persists the user's preferred menu layout mode and dispatches a synchronization event.
 */
export function setMenuLayoutModePref(mode: MenuLayoutMode): void {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(MENU_LAYOUT_STORAGE_KEY, mode);
      window.dispatchEvent(new CustomEvent('astro_menu_layout_changed', { detail: mode }));
    }
  } catch {}
}

